export const MAX_IFSC_LENGTH = 11;
export const MAX_PAN_LENGTH = 10;
export const MAX_GST_LENGTH = 15;

export const PHONE_REGEX = /^[0-9]{10}$/; 
export const EMAIL_REGEX = /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/; 
export const IFSC_REGEX = /^[A-Z]{4}[0][A-Z0-9]{6}$/; 
export const SWIFT_REGEX = /^[A-Z]{4}[A-Z]{2}[A-Z0-9]{2}([A-Z0-9]{3})?$/;
export const ACCOUNT_NUMBER_REGEX = /^[a-zA-Z0-9]{6,18}$/;
export const GST_REGEX = /^[0-9]{2}[A-Z]{5}[0-9]{4}[A-Z][0-9A-Z][Z][0-9A-Z]$/; 
export const PAN_REGEX = /^[A-Z]{5}[0-9]{4}[A-Z]$/; 
export const LANDLINE_REGEX = /^(0?\d{2,5}[-\s]?\d{6,8}|[2-9]\d{9})$/;
